import React from 'react';
import { MapPin, ExternalLink } from 'lucide-react';

export default function WhatsAppLocation({ location }) {
  const latitude = location?.latitude;
  const longitude = location?.longitude;
  const valid = typeof latitude === 'number' && Number.isFinite(latitude) && Math.abs(latitude) <= 90
    && typeof longitude === 'number' && Number.isFinite(longitude) && Math.abs(longitude) <= 180;
  return <section aria-label="Shared location" className="w-60 max-w-full space-y-2 py-1">
    <div className="flex items-start gap-2">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-700"><MapPin aria-hidden="true" className="h-5 w-5" /></span>
      <div className="min-w-0">
        <p className="break-words text-sm font-semibold">{location?.name || 'Shared location'}</p>
        {location?.address && <p className="break-words text-xs text-gray-600">{location.address}</p>}
        {valid && <p className="mt-1 text-xs text-gray-500">{latitude.toFixed(5)}, {longitude.toFixed(5)}</p>}
      </div>
    </div>
    {valid ? <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${latitude},${longitude}`)}`} target="_blank" rel="noopener noreferrer" className="flex min-h-[44px] items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium text-primary-700">
      Open in Maps<ExternalLink aria-hidden="true" className="h-4 w-4" />
    </a> : <p className="text-xs text-gray-600">Location details are unavailable. Ask the sender to share the location again.</p>}
  </section>;
}
